
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_34391_155874)"}},[_c('path',{attrs:{"d":"M14.822 9.218l.353-.353-1.06-1.06-1.94-1.94-1.06-1.06-.353.354-.706.706-6.225 6.225a2.772 2.772 0 00-.694 1.169l-1.106 3.762a.74.74 0 00.19.741.757.757 0 00.741.19l3.76-1.106c.44-.13.844-.368 1.169-.693l6.225-6.225.706-.71zM7 14.481l-.284.71a1.318 1.318 0 01-.416.215l-2.444.719.719-2.441c.044-.153.119-.294.216-.416l.709-.284v1c0 .275.225.5.5.5h1v-.003zm6.334-11.897l-.45.453-.706.706-.356.353 1.06 1.06 1.94 1.94 1.06 1.06.352-.353.707-.707.453-.453a2 2 0 000-2.828l-1.228-1.231a2 2 0 00-2.829 0h-.003zm-1.48 5.25l-4.5 4.5a.502.502 0 01-.707 0 .502.502 0 010-.706l4.5-4.5a.502.502 0 01.706 0 .502.502 0 010 .706z","fill":"#000"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_34391_155874"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(2 2)","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    